import { ConstructorModel } from '@common/core/models/constructor.model';
import { RoleModel } from './role.model';
import { UserTypeModel } from './user-type.model';
import { UserBrandStandModel } from './user-brand-stand.model';
import { PisoRoleModel } from '../piso/piso-role.model';

import _ from 'lodash';
import { FirestoreType, ModelAdapter } from '@common/interfaces/firestore/firestore.interface';

export class UserModel extends ConstructorModel {
  id: string;
  path: string;
  username: string;
  name: string;
  surname: string;
  email: string;
  phone: string;
  nationalId: string;
  photoURL: string;
  clockInId: number;
  lorealId: string;
  userType: UserTypeModel;
  registrationDate: string;
  unregistrationDate: string;
  role: RoleModel;
  pisoRole: PisoRoleModel;
  brandStand: Array<UserBrandStandModel>;
  estatura: number;
  talla: number;
  tallaChaqueta: string;
  tallaZapato: number;
  ZZ_TT: number;

    /** model constructor */
  constructor(data?: object) {
    super();

    this.id = this.setId('id', data) ;
    this.path = this.setString('path', data);
    this.username = this.setString('username', data);
    this.name = this.setString('name', data);
    this.surname = this.setString('surname', data);
    this.email = this.setString('email', data);
    this.phone = this.setString('phone', data);
    this.nationalId = this.setString('nationalId', data);
    this.photoURL = this.setString('photoURL', data);
    this.clockInId = this.setNumber('clockInId', data);
    this.lorealId = this.setString('lorealId', data);
    this.userType = this.setEntity('userType', UserTypeModel, data);
    this.registrationDate = this.setDate('registrationDate', data);
    this.unregistrationDate = this.setDate('unregistrationDate', data);
    this.role = this.setEntity('role', RoleModel, data);
    this.pisoRole = this.setEntity('pisoRole', PisoRoleModel, data);
    this.brandStand = this.setEntityList('brandStand', UserBrandStandModel, data, null);
    this.estatura = this.setNumber('estatura', data);
    this.talla = this.setNumber('talla', data);
    this.tallaChaqueta = this.setString('tallaChaqueta', data);
    this.tallaZapato = this.setNumber('tallaZapato', data);
    this.ZZ_TT = this.setNumber('ZZ_TT', data);
  }

  static adapter(): ModelAdapter {
    return {
        username: { name: 'LOGIN', type: FirestoreType.string },
        name: { name: 'NOMBRE_USUARIO', type: FirestoreType.string },
        surname: { name: 'APELLIDOS_USUARIO', type: FirestoreType.string },
        email: { name: 'EMAIL', type: FirestoreType.string },
        phone: { name: 'MOVIL_USUARIO', type: FirestoreType.string },
        registrationDate: { name: 'FECHA_ALTA_USUARIO', type: FirestoreType.datetime },
        unregistrationDate: { name: 'FECHA_BAJA_USUARIO', type: FirestoreType.datetime },
        nationalId: { name: 'DNI_USUARIO', type: FirestoreType.string },
        photoURL: { name: 'FOTO_USUARIO', type: FirestoreType.byte },
        clockInId: { name: 'ID_FICHAR', type: FirestoreType.number },
        lorealId: { name: 'ID_LOREAL', type: FirestoreType.number },
        userType: { name: 'Ref_ID_TIPO_USUARIO', type: FirestoreType.reference, modelClass: UserTypeModel },
        role: { name: 'Ref_USU_ROL_Id', type: FirestoreType.reference, modelClass: RoleModel },
        pisoRole: { name: 'Ref_NID_ROL', type: FirestoreType.reference, modelClass: PisoRoleModel },
        brandStand: { name: 'USUARIO_MARCA_STAND', type: FirestoreType.collection, modelClass: UserBrandStandModel },
        estatura: { name: 'ESTATURA', type: FirestoreType.number },
        talla: { name: 'TALLA', type: FirestoreType.number  },
        tallaChaqueta: { name: 'TallaChaqueta', type: FirestoreType.string },
        tallaZapato: { name: 'TallaZapato', type: FirestoreType.number },
        ZZ_TT: { name: 'ZZ_TT', type: FirestoreType.number },
      };
  }

  public getFullName(): string {
    return _.trim([this.name, this.surname].join(' '));
  }
}
